"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var DisplayMessage_models_1 = require("./DisplayMessage.models");

var settings_1 = require("../../settings");

exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  font-size: 1.3rem;\n  line-height: 1em;\n  padding: 1em;\n  text-align: center;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  font-size: 1.3rem;\n  line-height: 1em;\n  padding: 1em;\n  text-align: center;\n"])), function (_a) {
  var type = _a.type;
  return type === DisplayMessage_models_1.DisplayMessageType.SUCCESS ? settings_1.settings.colours.correct : type === DisplayMessage_models_1.DisplayMessageType.WARNING ? settings_1.settings.colours.warning : settings_1.settings.colours.error;
}, settings_1.settings.colours.textDisplayMessage);
var templateObject_1;